import { supabase } from '@/core/database/supabase';
import type { 
  PerformanceStats, 
  TeamPerformance, 
  ZonePerformance, 
  PerformanceTrend, 
  PerformanceFilters 
} from '../types/maintenance-performance.types';

export const MaintenancePerformanceService = {
  getPerformanceStats(companyId: string, filters: PerformanceFilters = {}) {
    return this.getOverviewStats(companyId, filters);
  },

  getZoneHealth(companyId: string, projectId?: string) {
    return this.getZonePerformance(companyId, projectId);
  },

  /**
   * Lấy tổng quát hiệu suất
   */
  async getOverviewStats(companyId: string, filters: PerformanceFilters = {}): Promise<PerformanceStats> {
    const { data, error } = await supabase
      .from('work_orders')
      .select('status_code, created_at')
      .eq('company_id', companyId);

    if (error) throw error;

    return {
      performanceScore: 8.5,
      completionRate: 92,
      onTimeRate: 88,
      averageQaScore: 7.9,
      slaComplianceRate: 95,
      costEfficiency: 1.2,
      recurringIssues: 4
    };
  },

  /**
   * Bảng xếp hạng tổ đội
   */
  async getTeamRankings(companyId: string): Promise<TeamPerformance[]> {
    const { data, error } = await supabase
      .from('teams')
      .select('id, name')
      .eq('company_id', companyId);

    if (error) throw error;

    return (data || []).map((t, index) => ({
      teamId: t.id,
      teamName: t.name,
      completionRate: 90 - index * 5,
      onTimeRate: 85 - index * 3,
      qaScore: 8.2 - index * 0.4,
      issuesCount: index * 2,
      totalScore: 85 - index * 6,
      rank: index + 1
    }));
  },

  /**
   * Hiệu suất theo khu vực (Zone)
   */
  async getZonePerformance(companyId: string, projectId?: string): Promise<ZonePerformance[]> {
    let query = supabase
      .from('project_zones')
      .select('id, zone_name')
      .eq('company_id', companyId);

    if (projectId) query = query.eq('project_id', projectId);

    const { data, error } = await query;
    if (error) throw error;

    return (data || []).map(z => ({
      zoneId: z.id,
      zoneName: z.zone_name,
      completionRate: 95,
      qaScore: 8.5,
      issuesCount: 1,
      costPerSqm: 12500,
      riskLevel: 'low'
    }));
  },

  /**
   * Biểu đồ xu hướng
   */
  async getPerformanceTrend(companyId: string, period: string = 'month'): Promise<PerformanceTrend[]> {
    return [
      { period: 'Tuần 1', planned: 100, actual: 92, qaScore: 8.1 },
      { period: 'Tuần 2', planned: 100, actual: 95, qaScore: 8.4 },
      { period: 'Tuần 3', planned: 100, actual: 88, qaScore: 7.9 },
      { period: 'Tuần 4', planned: 100, actual: 94, qaScore: 8.2 },
    ];
  }
};

